export default __webpack_public_path__ + "static/media/setting-icon-hover.069b0f5e.svg";